import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginForm } from '@/features'
import { isAuthenticated } from '@/store';

export const Route = createFileRoute('/')({
  component: LoginForm,
  loader: () => {
    if (isAuthenticated()) {
      throw redirect({
        to: '/sync',
      })
    }
  },
})